import app from "firebase/app";
import "firebase/auth";
import "firebase/database";
const config = {
  /* DEV */
  // apiKey: "AIzaSyBCJXsChGR-R6_SNIIoGE11yCRDZV_MDX8",
  // authDomain: "aone-dev.firebaseapp.com",
  // databaseURL: "https://aone-dev.firebaseio.com",
  // projectId: "aone-dev",
  // storageBucket: "aone-dev.appspot.com",
  // messagingSenderId: "622770248983"

  /* PROD */
  apiKey: "AIzaSyAVVHvGvd4nT5GXX6FrmnAJoqJDiLrQUPY",
  authDomain: "aone-mobile-app-backend.firebaseapp.com",
  databaseURL: "https://aone-mobile-app-backend.firebaseio.com",
  projectId: "aone-mobile-app-backend",
  storageBucket: "aone-mobile-app-backend.appspot.com",
  messagingSenderId: "292894451450"
};
class Firebase {
  constructor() {
    app.initializeApp(config);

    this.auth = app.auth();
    this.db = app.database();
  }

  /* Auth APIs */

  doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSignOut = () => this.auth.signOut();

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doPasswordUpdate = password => this.auth.currentUser.updatePassword(password);

  /* Entity APIs*/
  customers = () => this.db.ref("customers");
  addresses = () => this.db.ref("addresses");

  config = () => this.db.ref("config");
  orders = () => this.db.ref("orders");

  customer = uid => this.db.ref(`customers/${uid}`);
}

export default Firebase;
